// extracted by mini-css-extract-plugin
module.exports = {"home":"styles_home__8Zs8X","modal":"styles_modal__kGylT","form":"styles_form__ZLyhd","pulse":"styles_pulse__dHkFz","spin":"styles_spin__dKfDz"};